<template>
  <main class="bg_gray default-container-width relative">
    <div class="container-fluid">
      <div class="dash_header">
        <h1 class="heading font_bold">
          Welcome back{{ userName }}!
        </h1>
        <button
          v-if="user && (user.permissions.dashboard_permission === 'EDIT')"
          class="btn btn-md primary_btn settings_menu"
          @click="settings = !settings"
        >
          <span>
            <svg
              fill="none"
              height="18"
              viewBox="0 0 18 18"
              width="18"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="9.00004"
                cy="9"
                r="2.66667"
                stroke="#FFFFFF"
                stroke-width="1.41667"
              />
              <path
                d="M7.78485 2.36124C8.33493 1.44326 9.66515 1.44326 10.2152 2.36124L10.5825 2.9741C10.9033 3.50945 11.5366 3.7718 12.142 3.62009L12.8351 3.44641C13.8732 3.18627 14.8138 4.12688 14.5536 5.16495L14.3799 5.858C14.2282 6.46339 14.4906 7.09675 15.0259 7.41755L15.6388 7.7848C16.5568 8.33489 16.5568 9.6651 15.6388 10.2152L15.0259 10.5824C14.4906 10.9032 14.2282 11.5366 14.3799 12.142L14.5536 12.835C14.8138 13.8731 13.8732 14.8137 12.8351 14.5536L12.142 14.3799C11.5366 14.2282 10.9033 14.4905 10.5825 15.0259L10.2152 15.6388C9.66515 16.5567 8.33493 16.5567 7.78485 15.6388L7.4176 15.0259C7.0968 14.4905 6.46344 14.2282 5.85804 14.3799L5.165 14.5536C4.12693 14.8137 3.18632 13.8731 3.44646 12.835L3.62013 12.142C3.77184 11.5366 3.5095 10.9032 2.97414 10.5824L2.36128 10.2152C1.44331 9.6651 1.44331 8.33489 2.36128 7.7848L2.97414 7.41755C3.5095 7.09675 3.77184 6.46339 3.62013 5.858L3.44646 5.16495C3.18632 4.12688 4.12693 3.18627 5.165 3.44641L5.85804 3.62009C6.46344 3.7718 7.0968 3.50945 7.4176 2.9741L7.78485 2.36124Z"
                stroke="#FFFFFF"
                stroke-width="1.41667"
              />
            </svg>
          </span>
          <transition name="fade">
            <ul
              v-show="settings"
              class="select_dropdown"
              @mouseleave="settings = false"
            >
              <li>
                <a
                  href="javascript:;"
                  @click="enableEditing()"
                >
                  <i class="icon edit_icon" />
                  <span>Edit Layout</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openAddWidgetModal()"
                >
                  <i class="icon add_icon" />
                  <span>Add Widget</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="openMyWidgetsModal()"
                >
                  <i class="far fa-folders" />
                  <span>My Widgets</span>
                </a>
              </li>
              <li>
                <a
                  href="javascript:;"
                  @click="getSharableLink()"
                >
                  <i class="far fa-share-alt" />
                  <span>Shareable link</span>
                </a>
              </li>
            </ul>
          </transition>
        </button>
      </div>

      <KitUpgradeBanner />

      <div
        v-if="editing"
        class="editing_layout"
      >
        Editing Layout
        <button
          class="btn btn_sm primary_btn"
          @click="saveLayout()"
        >
          <span>
            <i
              v-if="saving"
              class="fa fa-btn fa-spinner fa-spin"
            />
            {{ saving ? 'Saving' : 'Save' }}
          </span>
        </button>
        <button
          class="btn btn_sm btn-danger"
          @click="cancelEditing()"
        >
          <span>
            Cancel
          </span>
        </button>
      </div>

      <CancellingWebsiteWarning
        v-if="showWebsiteCancellingWarning"
        :website-id="activeWebsite.hash_id"
        :end-date="websiteEndDateFormatted"
      />

      <gridstack-container
        :key="gridKey"
        :editing="editing"
      />
    </div>
  </main>
  <AddIndustry />
  <AcceptTermsModal
    v-if="showNewTerms"
    :current-tos-version="currentTosVersion"
  />
</template>

<script>
import {mapActions, mapMutations, mapState} from 'vuex';
import GridstackContainer from './components/GridstackContainer.vue'
import AddIndustry from "./components/modals/AddIndustry";
import AcceptTermsModal from "@/components/compliance/modals/AcceptTermsModal.vue";
import moment from 'moment';
import KitUpgradeBanner from "@/components/kit/upgrade/KitUpgradeBanner.vue";

export default {
  components: {
    KitUpgradeBanner,
    AddIndustry,
    GridstackContainer,
    AcceptTermsModal,
  },
  props: {
    whitelabel: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      settings: false,
      saving: false,
      editing: false,
      gridKey: 0,
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapState('dashboard', [
      'activeWebsite',
      'uuid'
    ]),
    userName() {
      if (this.user) {
        if (this.user.name.trim()) {
          return `, ${this.user.name}`;
        }
      }

      return '';
    },
    showNewTerms() {
        return this.user
            && this.user.permissions.organisation_permission === 'EDIT'
            && this.user.organisation.requires_tos_acceptation
    },
    showWebsiteCancellingWarning() {
      return this.user
          && this.activeWebsite
          && this.user.permissions.organisation_permission === 'EDIT'
          && this.user.organisation.is_merchant_user === false
          && this.activeWebsite.subscription_status === 'CANCELLING'
    },
    websiteEndDateFormatted() {
      return moment(this.activeWebsite.subscription_status_datetime).format('Do MMMM YYYY')
    },
  },
  watch: {
    activeWebsite: {
      handler() {
        this.getTrafficData(this.activeWebsite.id)
      },
    },
  },
  mounted() {
    this.getUser()
      .then(() => {
        this.setActiveWebsite(this.user.active_website);
        this.getCountryFlags();
        this.getLayout();
        this.getCustomWidgets();
        this.getCompetitors();
        this.getGMBLocations();
      });
  },
  methods: {
    ...mapActions({
      getUser: 'user/getUser',
      getCountryFlags: 'dashboard/getCountryFlags',
      getLayout: 'dashboard/getLayout',
      openAddWidgetModal: 'dashboard/openAddWidgetModal',
      openMyWidgetsModal: 'dashboard/openMyWidgetsModal',
      saveDashLayout: 'dashboard/saveLayoutRequest',
      getCustomWidgets: 'dashboard/getCustomWidgets',
      getTrafficData: 'dashboard/getTrafficData',
      getGMBLocations: 'dashboard/getGMBLocations',
      getCompetitors: 'lookups/getCompetitors',
    }),
    ...mapMutations({
      setActiveWebsite: 'dashboard/setActiveWebsite',
    }),
    enableEditing() {
      this.editing = true;
      this.gridKey++;
    },
    saveLayout() {
      this.saving = true;
      this.saveDashLayout().then(() => {
        this.gridKey++;
        this.saving = false;
        this.editing = false;
      });
    },
    cancelEditing() {
      this.gridKey++;
      this.getTrafficData(this.activeWebsite.id)
      this.editing = false;
    },
    getSharableLink() {
      let url = new URL(window.location.href);
      navigator.clipboard.writeText(`${url.host}/dashboard/${this.uuid}`);

      this.SweetToast.fire({
        icon: 'success',
        title: 'Url copied to clipboard'
      });
    }
  },

}
</script>

<style scoped>
.dash_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 1rem;
  background: #f4f4f4;
}

.dash_header .heading {
  line-height: 1.25;
  letter-spacing: -0.042em;
  color: #040707;
  font-size: 2.5rem;
  margin: 0;
}

.dash_toolbar {
  margin-bottom: 1rem;
}

.dash_toolbar button {
  margin: 0;
}

.settings_menu {
  margin: 0;
}

.settings_menu span {
  display: flex;
  align-items: center;
}

.select_dropdown {
  right: 5px;
  margin: 10px;
  z-index: 101;
  position: absolute;
  width: 190px;
  padding: 1rem;
  background-color: white;
  border: 1px solid #C7C4C1;
  border-radius: .75rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  list-style: none;
}

.select_dropdown li {
  padding: .25rem 0;
}

.select_dropdown li a {
  display: block;
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  line-height: 24px;
  letter-spacing: -0.1px;
  border-radius: 0.5rem;
  -webkit-transition: .3s;
  -o-transition: .3s;
  transition: .3s;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: var(--primary-font-color);
}

.select_dropdown li a:hover {
  background-color: #FFEEEA;
}

.select_dropdown li hr {
  margin: 0.5rem 0;
}

.select_dropdown li a i,
.select_dropdown li a svg {
  height: 1rem;
  width: 1rem;
  margin-right: 0.5rem;
}

.select_dropdown li a span i {
  margin-right: 0;
}

.select_dropdown li a span {
  color: var(--primary-font-color);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.editing_layout {
  background: red;
  border-radius: 10px;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  position: sticky;
  top: 65px;
  z-index: 11;
}

.editing_layout button {
  margin: 0;
  margin-left: 0.5rem;
}
</style>
